import { render, staticRenderFns } from "./Migalhas.vue?vue&type=template&id=37c14927&"
import script from "./Migalhas.vue?vue&type=script&lang=js&"
export * from "./Migalhas.vue?vue&type=script&lang=js&"
import style0 from "./Migalhas.vue?vue&type=style&index=0&id=37c14927&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports